import { useQuery } from "@tanstack/react-query";
import { getOrder } from "./ordersApi";

export const useOrderWithId = (orderId: string | null) => {
  const { data: order, isLoading } = useQuery({
    queryKey: ["orders", orderId],
    queryFn: ({ signal }) => (!orderId ? null : getOrder(orderId, signal)),
    enabled: orderId !== null,
  });
  return { order, isLoading };
};
